<template>
  <div class="card blog">
    <div v-if="loadError" class="card-body">
      <h1 class="h2">{{ loadError }}</h1>
      <router-link to="/blog">Все новости</router-link>
    </div>
    <div v-if="post" class="card-body">
      <div class="d-flex align-items-center">
        <button aria-label="Вернуться к новостям" class="btn btn-link me-2" @click="router.push('/blog')">
          <img src="@/assets/images/icons/arrow.svg" class="back-icon" alt="" />
        </button>
        <h1 class="h2 mb-0">{{ post.title }}</h1>
      </div>
      <div class="blog-block text-start mt-4">
        <img
          :src="post.image || require('@/assets/images/logo_info.svg')"
          :alt="post.title"
          class="blog-block__mainimage"
          decoding="async"
        />
        <div class="mt-4" v-html="post.content"></div>
        <p class="date">{{ formatDate(post.created_at) }}</p>
        <button class="black-button" @click="router.push('/blog')">Все новости</button>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineComponent, onMounted, ref } from 'vue';
  import moment from 'moment';
  import MarketplaceService from '@/services/marketplace';
  import { useRouter, useRoute } from 'vue-router';

  export default defineComponent({
    name: 'Post',
    setup() {
      const post = ref(null);
      const loadError = ref('');
      const router = useRouter();
      const route = useRoute();

      const formatDate = (date) => {
        return moment(date).format('hh:mm DD.MM.YYYY');
      };

      onMounted(() => {
        MarketplaceService.getPost(route.params.id)
          .then((res) => {
            post.value = res;
          })
          .catch((error) => {
            loadError.value =
              error.response?.status === 404
                ? 'Публикация не найдена'
                : 'Не удалось загрузить публикацию. Обновите страницу.';
          });
      });
      return { post, loadError, formatDate, router };
    },
  });
</script>

<style lang="scss">
  @import '@/assets/styles/Blog';
</style>
